var _path, _path2, _g, _path3, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAltersverifizierungIdCardFront = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 133,
    viewBox: "0 0 226 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_707_7585)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221.754 0H4.22266C2.01352 0 0.222656 1.79086 0.222656 4V128.8C0.222656 131.009 2.01352 132.8 4.22266 132.8H221.754C223.963 132.8 225.754 131.009 225.754 128.8V4C225.754 1.79086 223.963 0 221.754 0Z",
    stroke: "#AAAAAA",
    strokeWidth: 1.6,
    strokeDasharray: "4 4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_707_7585",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 28,
    width: 75,
    height: 75
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.518 102.007C70.7507 102.007 87.1525 85.6051 87.1525 65.3724C87.1525 45.1397 70.7507 28.7379 50.518 28.7379C30.2854 28.7379 13.8835 45.1397 13.8835 65.3724C13.8835 85.6051 30.2854 102.007 50.518 102.007Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_707_7585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.518 102.007C70.7507 102.007 87.1525 85.6051 87.1525 65.3724C87.1525 45.1397 70.7507 28.7379 50.518 28.7379C30.2854 28.7379 13.8835 45.1397 13.8835 65.3724C13.8835 85.6051 30.2854 102.007 50.518 102.007Z",
    fill: "#061437",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.518 73.4816C59.6859 73.4816 67.118 66.0495 67.118 56.8816C67.118 47.7137 59.6859 40.2816 50.518 40.2816C41.35 40.2816 33.918 47.7137 33.918 56.8816C33.918 66.0495 41.35 73.4816 50.518 73.4816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.518 134.757C66.5619 134.757 79.568 121.751 79.568 105.707C79.568 89.6632 66.5619 76.6571 50.518 76.6571C34.4741 76.6571 21.468 89.6632 21.468 105.707C21.468 121.751 34.4741 134.757 50.518 134.757Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_707_7585",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 28,
    width: 75,
    height: 75
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.518 102.007C70.7507 102.007 87.1525 85.6051 87.1525 65.3724C87.1525 45.1397 70.7507 28.7379 50.518 28.7379C30.2854 28.7379 13.8835 45.1397 13.8835 65.3724C13.8835 85.6051 30.2854 102.007 50.518 102.007Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_707_7585)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M188.207 23.5862H108.749C107.613 23.5862 106.692 24.5072 106.692 25.6433V31.8325C106.692 32.9686 107.613 33.8896 108.749 33.8896H188.207C189.343 33.8896 190.264 32.9686 190.264 31.8325V25.6433C190.264 24.5072 189.343 23.5862 188.207 23.5862Z",
    fill: "#061437",
    fillOpacity: 0.12
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144.401 79.1921H108.749C107.613 79.1921 106.692 80.1132 106.692 81.2493V83.0227C106.692 84.1588 107.613 85.0798 108.749 85.0798H144.401C145.537 85.0798 146.458 84.1588 146.458 83.0227V81.2493C146.458 80.1132 145.537 79.1921 144.401 79.1921Z",
    fill: "#061437",
    fillOpacity: 0.12
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M199.008 79.1921H163.356C162.22 79.1921 161.299 80.1132 161.299 81.2493V83.0227C161.299 84.1588 162.22 85.0798 163.356 85.0798H199.008C200.144 85.0798 201.066 84.1588 201.066 83.0227V81.2493C201.066 80.1132 200.144 79.1921 199.008 79.1921Z",
    fill: "#061437",
    fillOpacity: 0.12
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.229969,
    d: "M108.749 43.5482H208.814C209.674 43.5482 210.371 44.2454 210.371 45.1054V51.2945C210.371 52.1545 209.674 52.8517 208.814 52.8517H108.749C107.889 52.8517 107.192 52.1545 107.192 51.2945V45.1054C107.192 44.2454 107.889 43.5482 108.749 43.5482Z",
    fill: "#061437",
    fillOpacity: 0.36,
    stroke: "#AAAAAA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.229969,
    d: "M108.749 90.8134H154.207C155.067 90.8134 155.764 91.5105 155.764 92.3705V94.1439C155.764 95.0039 155.067 95.701 154.207 95.701H108.749C107.889 95.701 107.192 95.0039 107.192 94.1439V92.3705C107.192 91.5105 107.889 90.8134 108.749 90.8134Z",
    fill: "#061437",
    fillOpacity: 0.36,
    stroke: "#AAAAAA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.229969,
    d: "M163.356 90.8134H208.814C209.674 90.8134 210.371 91.5105 210.371 92.3705V94.1439C210.371 95.0039 209.674 95.701 208.814 95.701H163.356C162.496 95.701 161.799 95.0039 161.799 94.1439V92.3705C161.799 91.5105 162.496 90.8134 163.356 90.8134Z",
    fill: "#061437",
    fillOpacity: 0.36,
    stroke: "#AAAAAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_707_7585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 225.531,
    height: 132.8,
    fill: "white",
    transform: "translate(0.222656)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAltersverifizierungIdCardFront);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/altersverifizierung-id-card-front.12b2b2073b5f8019d47a4c01a5b20a99.svg";